import React from 'react';
import { Controller } from 'react-hook-form';
import { InputFieldText } from 'components/Ui/styled';

export const FormInputText = (props) => {
  const {
    name,
    control,
    label,
    type,
    shrink,
    multiline,
    rows,
    minRows,
    maxRows,
    disabled,
    register,
    minValue,
    maxValue,
    errors,
    helperText,
    placeholder,
    readOnly,
    onKeyDown,
    endAdornment,
    testId,
    sx,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      register={register}
      render={({ field: { onChange, value } }) => (
        <InputFieldText
          onChange={onChange}
          data-testid={testId || label}
          value={value == null ? '' : value}
          disabled={disabled}
          label={label}
          type={type}
          variant="standard"
          multiline={multiline}
          minRows={minRows}
          maxRows={maxRows}
          error={errors}
          helperText={helperText}
          placeholder={placeholder}
          rows={rows}
          InputLabelProps={{ shrink }}
          InputProps={{
            inputProps: { min: minValue, max: maxValue },
            readOnly: readOnly,
            onKeyDown: onKeyDown,
            endAdornment: endAdornment,
          }}
          sx={{ ...sx }}
          style={{ width: '100%' }}
        />
      )}
    />
  );
};
